import fetch from '../utils/fetch'

// 結算彙總
export function getSummary (params) {
  return fetch({
    url: '/statement/summarized',
    method: 'get',
    params
  })
}

// 新增店鋪結算週期設定
export function addPeriodSetting (params) {
  return fetch({
    url: '/statement/period/setting',
    method: 'post',
    params
  })
}

// 獲取預設結算週期配置
export function getDefaultSetting (params) {
  return fetch({
    url: '/statement/period/default/setting',
    method: 'get',
    params
  })
}

// 儲存結算週期設定
export function savePeriodSetting (params) {
  return fetch({
    url: '/statement/period/setting',
    method: 'post',
    params
  })
}

// 確認結算
export function confirmStatement (id) {
  return fetch({
    url: `/statement/confirm/${id}`,
    method: 'post'
  })
}

// 匯出
export function exportData (params) {
  return fetch({
    url: `/statement/summarized/export`,
    method: 'post',
    params
  })
}

// 匯出明細
export function exportDetialData (params) {
  return fetch({
    url: `/statement/detail/export`,
    method: 'post',
    params
  })
}
